import React, { useState, useEffect } from "react";
import {
  Modal,
  Button,
  Space,
  Input,
  Form,
  Radio,
  Select,
  message,
  notification,
} from "antd";
import { Table } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import "../css/product.css";
import axios from "axios";
import { path, src } from "../network/conn";
import { EditFilled } from "@ant-design/icons";
const key = "updatable";
const openMessageLoading = (load) => {
  message.loading({ content: load, key });
};
const openMessageSuccess = (loaded) => {
  message.success({ content: loaded, key, duration: 2 });
};
const logUser = window.sessionStorage.getItem("user");
const Masterpayment = (props) => {
  const [loading, setLoading] = useState(false);
  const [visible, setVisible] = useState(false);
  const [dataSource, setdataSource] = useState([]);
  const [size, setSize] = useState();
  const [totalRecord, settotalRecord] = useState(0);
  const [submitType, setsubmitType] = useState("insert");
  const [userSetting,setUserSetting] = useState({});
  const [form] = Form.useForm();

  const addpayment = () => {
    setsubmitType("insert");
    fetchCount();
    showLargeDrawer();
  };
  const showLargeDrawer = () => {
    setSize("large");
    setVisible(true);
  };
  const drawerClose = () => {
    setVisible(false);
    form.resetFields();
  };
  const layout = {
    labelCol: { span: 5 },
    wrapperCol: { span: 10 },
  };
  const onFinish = (e) => {
    const data = e;
    data['user'] = logUser;
    openMessageLoading("Adding Payment", 20);
    let BaseURL = path + src + "insertpayment.php";
    axios
      .post(BaseURL, data)
      .then((response) => {
        openMessageSuccess(response.data, 20);
        drawerClose();
        fetchTableData();
      })
      .catch((error) => {
        openMessageSuccess(error, 10);
      });
  };

  const fetchTableData = () => {
    setLoading(true);
    let BaseURL = path + src + "paymentlist.php";
    axios
      .get(BaseURL)
      .then((response) => {
        let filteredArr = response.data.filter((list)=>{return list.code!="cash"});
        let filteredArred = filteredArr.sort((a,b)=>{return b.sno - a.sno});
        setdataSource(filteredArred);
        setdataSource(filteredArr);
        settotalRecord(filteredArr.length);
        drawerClose();
        setLoading(false);
      })
      .catch((error) => {
        openMessageSuccess(error, 10);
      });
  };
  const fetchCount = () => {
  
        let value = dataSource.length + 1 ; 
        let valueStr = "0000"+ value.toString();
        settotalRecord(dataSource.length);
        form.setFieldsValue({
          code: "PTM-" + (valueStr.substr(-4)),
          submit: "insert",
        });
  };
  const onEditLabour = (record) => {
    setsubmitType("update");
    console.log(submitType);
    showLargeDrawer();
    let response = dataSource.filter((list)=>{return list.code == record.code});
    console.log(response);
      form.setFieldsValue({
        code: response[0].code,
        payment: response[0].payment,
        date: response[0].date,
        time: response[0].time,
        submit: "update",
      })
  };
  const profile = window.sessionStorage.getItem("profile");
  const fetch_profile_permission = (profile) =>{
    console.log('profile',profile);
    let BaseURL = path + src + "fetch_profile_permission.php?profile="+profile;
    axios
    .get(BaseURL)
      .then((response) => {
        console.log(response.data);
        let dataObj = {};
        response.data.map((list)=>{
          let permissionObj = {};
          if(list.filename == 'masterpayment'){
          permissionObj['add']      = list.add;
          permissionObj['edit']     = list.edit;
          permissionObj['delete']   = list.delete;
          permissionObj['show']     = list.show;
          permissionObj['print']    = list.print;
          permissionObj['excel']    = list.excel;
          permissionObj['profile']  = list.profile;
          dataObj[list.filename]    =  permissionObj;
          setUserSetting(permissionObj);
          }
        })
       
       console.log('dataObj',dataObj);
      })
      .catch((error) => {
        //openMessageSuccess(error, 10);
        console.log(error);
      });
    }
  useEffect(() => {
    fetch_profile_permission(profile);
    fetchTableData();
  }, []);
  const columns = [
    {
      key: "1",
      title: "Sno",
      dataIndex: "sno",
      sorter: (record1, record2) => {
        return record1.id > record2.id;
      },
    },
    {
      key: "2",
      title: "Code",
      dataIndex: "code",
    },
    {
      key: "3",
      title: "Payment",
      dataIndex: "payment",
      filterDropdown: ({
        setSelectedKeys,
        selectedKeys,
        confirm,
        clearFilters,
      }) => {
        return (
          <>
            <Input
              placeholder="Type To Search"
              autoFocus
              value={selectedKeys[0]}
              onChange={(e) => {
                setSelectedKeys(e.target.value ? [e.target.value] : []);
                confirm({ closeDropdown: false });
              }}
              onBlur={() => {
                confirm({ closeDropdown: false });
              }}
            ></Input>
          </>
        );
      },
      filterIcon: () => {
        return <SearchOutlined />;
      },
      onFilter: (value, record) => {
        return record.payment.toLowerCase().includes(value.toLowerCase());
      },
    },
    {
      key: "6",
      title: "Edit",
      render: (record) => (
        Number(userSetting.edit == 1 ) ? <Button
          title="Edit"
          size="small"
          type="primary"
          onClick={() => {
            onEditLabour(record);
          }}
        >
          <EditFilled />
        </Button> : ''
      ),
    },
    // {
    //   key: "7",
    //   title: "Delete",
    //   render: (record) => (
    //     <Button
    //       title="Edit"
    //       size="small"
    //       type="danger"
    //       onClick={() => {
    //         openNotification(record);
    //       }}
    //     >
    //       Delete
    //     </Button>
    //   ),
    // },
  ];

  return (
    <>
      <Space>
      {Number(userSetting.add) == 1 ? <Button type="primary" onClick={addpayment}>
          Add Payment +
        </Button> : '' }  
      </Space>
      <Modal
        title={submitType == "insert" ? "Add Payment" : "Edit Payment"}
        style={{ top: 20 }}
        visible={visible}
        onOk={() => drawerClose()}
        onCancel={() => drawerClose()}
        width={"90vw"}
        maskClosable={false}
        footer={null}
      >
        <Form {...layout} form={form} name="nest-messages" onFinish={onFinish}>
          <Form.Item
            name="code"
            label="Code"
            rules={[{ required: true }]}
          >
            <Input placeholder="Enter Your Code"  style={{color:"red"}} disabled={true} autocomplete="off" />
          </Form.Item>
          <Form.Item
            name="payment"
            label="PaymentMethod"
            rules={[{ required: true }]}
          >
            <Input placeholder="Enter Your Payment" autocomplete="off" />
          </Form.Item>
          <Form.Item
            name="submit"
            label="sumit"
            value={submitType}
            rules={[{ required: false }]}
            hidden={true}
          >
            <Input placeholder="Submit" autocomplete="off" />
          </Form.Item>
          <Form.Item
            name="date"
            label="submit"
            rules={[{ required: false }]}
            hidden={true}
          >
            <Input placeholder="Submit" autocomplete="off" />
          </Form.Item>
          <Form.Item
            name="time"
            label="sumit"
            rules={[{ required: false }]}
            hidden={true}
          >
            <Input placeholder="Submit" autocomplete="off" />
          </Form.Item>
          <Form.Item>
            <Button type="primary" htmlType="submit">
              {submitType == "insert" ? "Submit" : "Update"}
            </Button>
          </Form.Item>
        </Form>
      </Modal>
      <Table
        bordered
        className="tableData"
        dataSource={dataSource}
        columns={columns}
        loading={loading}
        pagination={{ pageSize: 5, total: { totalRecord } }}
      ></Table>
    </>
  );
};
export default Masterpayment;
